module.exports = __webpack_public_path__ + "static/media/Dual_8000.227bb6ef.jpg";